"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.DfvComponent = void 0;
require('../dfv/dfv.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var DfvComponent = /** @class */ (function () {
    function DfvComponent($rootScope, $scope, $timeout) {
        this.isOverflown = function (_a) {
            var clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            return scrollHeight > clientHeight;
        };
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DFV);
        ctrl.$scope = $scope;
        ctrl.$rootScope = $rootScope;
        ctrl.options = { show: true, id: -1 };
        ctrl.$timeout = $timeout;
        ctrl.initListeners(ctrl);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $timeout();
    }
    DfvComponent.prototype.initListeners = function (ctrl) {
        ctrl.initBootstrapListeners(ctrl);
        ctrl.initDragListeners(ctrl);
        ctrl.initDFVListeners(ctrl);
    };
    DfvComponent.prototype.initBootstrapListeners = function (ctrl) {
        ctrl.$scope.$on('saveDFV', function (event, args) {
            ctrl.selectedIssue = __assign({}, args.selectedIssue);
            ctrl.saveFromDialog();
        });
        ctrl.$scope.$on('command:DFV', function (event, args) {
            ctrl.canvas = 'DFV';
            ctrl.initComponent(event, args);
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
        });
        ctrl.$scope.$on('command:GPE', function (event, args) {
            ctrl.canvas = 'GPE';
            ctrl.initComponent(event, args);
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
        });
    };
    DfvComponent.prototype.onStickyChange = function (id, stickyIndex, note) {
        var ctrl = this;
        ctrl.updateChangeDate(id, stickyIndex);
        ctrl.utilsService.setFontSize(note, id, stickyIndex);
        ctrl.saveDFV();
    };
    DfvComponent.prototype.initDragListeners = function (ctrl) {
        ctrl.$scope.$on('DragStart', function (event, args) {
            // console.log(args.id);
            ctrl.draggableItemId = args.id;
        });
        ctrl.$scope.$on('DragOver', function (event, args) {
            var el = document.getElementById(ctrl.draggableItemId);
            el.style.backgroundColor = ctrl.utilsService.issueType[args.type].COLOR;
            el.style.opacity = '0.4';
            var divCollection = [].slice.call(args.container[0].children);
            var dragAfterElement = ctrl.utilsService.getDragElement(divCollection, args.event.clientY);
            if (dragAfterElement) {
                // To get the target index of draggable item to be placed
                divCollection.find(function (x, index) {
                    ctrl.dropIndex = index;
                    return x == dragAfterElement;
                });
            }
            args.container[0].insertBefore(el.parentElement, dragAfterElement);
        });
    };
    DfvComponent.prototype.initDFVListeners = function (ctrl) {
        ctrl.$scope.$on('CopiedFromAllStickies', function (event, args) {
            ctrl.copiedFromAllStickies = args.status;
        });
        ctrl.$scope.$on('DropAddStickies', function (event, args) {
            ctrl.setIssueDetails(ctrl.utilsService.issueType.DEFAULT, ctrl.allStickies, args);
        });
        ctrl.$scope.$on('DropDesirability', function (event, args) {
            ctrl.setIssueDetails(ctrl.utilsService.issueType.DESIRABILITY, ctrl.desirability, args);
        });
        ctrl.$scope.$on('DropFeasibility', function (event, args) {
            ctrl.setIssueDetails(ctrl.utilsService.issueType.FEASIBILITY, ctrl.feasibility, args);
        });
        ctrl.$scope.$on('DropViability', function (event, args) {
            ctrl.setIssueDetails(ctrl.utilsService.issueType.VIABILITY, ctrl.viability, args);
        });
    };
    DfvComponent.prototype.setIssueDetails = function (type, array, args) {
        var ctrl = this;
        // Assuming moving from feasibility:0 (drag location) to desirability:2 (drop location)
        // Remove from drag location but when drop it to some other location (Either other index, or other dropzone)
        var dragEl = document.getElementById(ctrl.draggableItemId);
        var dragElArray = ctrl.draggableItemId.split(":"); // [0]: type, [1]: index
        // When not dropped at same location i.e Same index and same zone
        if (!((dragElArray[0] == type.NAME) && (dragElArray[1] == ctrl.dropIndex))) {
            args.container[0].removeChild(dragEl.parentElement);
        }
        ctrl.issueDetails = ctrl.getDataAndRemove(args.dfv, args.id);
        var previousType = ctrl.issueDetails.type;
        ctrl.issueDetails.type = type.NAME;
        ctrl.issueDetails.backgroundColor = type.COLOR;
        ctrl.issueDetails.updatedAt = ctrl.utilsService.updatedAt();
        //Add sticky to targeted position instead of end.
        array.splice(ctrl.dropIndex, 0, ctrl.issueDetails);
        // Set the opacity and color of updated element which has taken draggable item id
        if (dragEl) {
            dragEl.style.opacity = "1.0";
            dragEl.style.backgroundColor = ctrl.utilsService.issueType[previousType.toUpperCase()].COLOR;
        }
        // Adjust height of zone
        ctrl.desirability.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.feasibility.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.viability.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.saveDFV();
        ctrl.$scope.$apply();
    };
    DfvComponent.prototype.deleteSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                list.splice(i, 1);
                break;
            }
        }
        // Adjust height of zone
        list.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.saveDFV();
    };
    DfvComponent.prototype.deleteNode = function (issueId, list) {
        var ctrl = this;
        bootbox.dialog({
            message: "You are about to delete this issue. Are you sure?",
            title: "Confirm Deletion",
            buttons: {
                confirm: {
                    label: "Delete",
                    className: "btn-danger",
                    callback: function () {
                        ctrl.deleteSticky(issueId, list);
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    ;
    DfvComponent.prototype.showIssueInfo = function (issueId) {
        var ctrl = this;
        bootbox.dialog({
            message: "Node Id: " + ctrl.node._id + " <br> Issue Id: " + issueId,
            title: "Issue Info",
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    DfvComponent.prototype.resetAllStickies = function () {
        var ctrl = this;
        ctrl.allStickies = [];
    };
    DfvComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.selectedIssue = angular.copy(ctrl.origSelectedIssue);
        ctrl.selectedTypeConst = "DFV";
    };
    DfvComponent.prototype.getDataAndRemove = function (dfv, id) {
        var ctrl = this;
        var data = {};
        switch (dfv) {
            case ctrl.utilsService.issueType.DEFAULT.NAME:
                data = ctrl.allStickies[id];
                ctrl.removeIssueByIndex(ctrl.allStickies, id);
                break;
            case ctrl.utilsService.issueType.DESIRABILITY.NAME:
                data = ctrl.desirability[id];
                ctrl.removeIssueByIndex(ctrl.desirability, id);
                break;
            case ctrl.utilsService.issueType.FEASIBILITY.NAME:
                data = ctrl.feasibility[id];
                ctrl.removeIssueByIndex(ctrl.feasibility, id);
                break;
            case ctrl.utilsService.issueType.VIABILITY.NAME:
                data = ctrl.viability[id];
                ctrl.removeIssueByIndex(ctrl.viability, id);
                break;
        }
        return data;
    };
    DfvComponent.prototype.updateChangeDate = function (dfv, id) {
        var ctrl = this;
        switch (dfv) {
            case ctrl.utilsService.issueType.DEFAULT.NAME:
                ctrl.allStickies[id].updatedAt = ctrl.utilsService.updatedAt();
                break;
            case ctrl.utilsService.issueType.DESIRABILITY.NAME:
                ctrl.desirability[id].updatedAt = ctrl.utilsService.updatedAt();
                break;
            case ctrl.utilsService.issueType.FEASIBILITY.NAME:
                ctrl.feasibility[id].updatedAt = ctrl.utilsService.updatedAt();
                break;
            case ctrl.utilsService.issueType.VIABILITY.NAME:
                ctrl.viability[id].updatedAt = ctrl.utilsService.updatedAt();
                break;
        }
    };
    DfvComponent.prototype.addSticky = function () {
        var ctrl = this;
        // ctrl.allStickies.unshift(
        //     ctrl.utilsService.getNewSticky(ctrl.userName),
        // );
        var newGot = ctrl.utilsService.getNewSticky(ctrl.userName);
        newGot.isDfv = true;
        ctrl.allStickies.unshift(newGot);
        // Adjust height of zone
        ctrl.allStickies.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.saveDFV();
    };
    DfvComponent.prototype.onEditSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                ctrl.selectedIssue = angular.copy(list[i]);
                ctrl.origSelectedIssue = list[i];
                ctrl.theIndex = i;
                ctrl.theList = list;
                ctrl.$timeout(function () {
                    console.log('emit');
                    ctrl.$scope.$emit('issueModal', { 'modalData': ctrl.modalData, 'selectedIssue': ctrl.selectedIssue, 'node': ctrl.node,
                        'issueList': issue_list_1.IssueListEnum.DFV });
                    ctrl.$scope.$apply();
                }, 1000);
                break;
            }
        }
    };
    DfvComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.selectedTypeConst = "DFV";
    };
    DfvComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    DfvComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    DfvComponent.prototype.removeIssueByIndex = function (array, index) {
        if (index > -1) {
            array.splice(index, 1);
        }
    };
    DfvComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.userName = args.userName;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.menu = [];
        ctrl.selectedIssue = null;
        ctrl.desirability = [];
        ctrl.feasibility = [];
        ctrl.viability = [];
        ctrl.allStickies = [];
        ctrl.showMsg = false;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        ctrl.getDFVData();
    };
    DfvComponent.prototype.getDFVData = function () {
        var ctrl = this;
        ctrl.smartorg.getDFVData(ctrl.node._id).then(function (res) {
            if (res) {
                ctrl.initDFVData(res);
                ctrl.$timeout();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    DfvComponent.prototype.saveFromDialog = function () {
        var ctrl = this;
        ctrl.theList[ctrl.theIndex] = __assign({}, ctrl.selectedIssue);
        ctrl.showMsg = true;
        ctrl.saveDFV();
    };
    DfvComponent.prototype.saveDFV = function () {
        var ctrl = this;
        var dfvData = {
            addStickies: ctrl.allStickies,
            desirability: ctrl.desirability,
            feasibility: ctrl.feasibility,
            viability: ctrl.viability
        };
        dfvData = JSON.parse(angular.toJson(dfvData));
        ctrl.$timeout(function () {
            ctrl.smartorg.saveDFVData(ctrl.node._id, dfvData).then(function (ret) {
                if ('status' in ret && ret['status'] == 0) {
                    // ctrl.closeWarningDialog();
                    if (ctrl.showMsg) {
                        ctrl.showAlert('success', 'Success!', "Saved successfully.");
                        ctrl.clearSelection();
                        ctrl.clearAllObj();
                        ctrl.getDFVData();
                        ctrl.showMsg = false;
                    }
                    ctrl.$scope.$apply();
                }
                else {
                    ctrl.showAlert('danger', 'Error!', ret.message);
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
            });
        }, 500);
    };
    DfvComponent.prototype.formatIssueData = function (item) {
        var ctrl = this;
        item.description = 'description' in item ? item.description : "";
        var impactToBeUsed = ctrl.isQualitative ? item.impact : item.calcImpact;
        item.title = item.title ? item.title : item.name.substring(0, 13);
        // item.impact = impactToBeUsed;
        item.score = item.ignorance * impactToBeUsed;
        item.issueType = ctrl.utilsService.getDiscoveryGrid(item.ignorance, impactToBeUsed);
        item.issueColor = ctrl.utilsService.zoneColor[item.issueType.replace(/ /g, "")];
        if (item.experimentData.length > 0) {
            item.experimentData = item.experimentData[0];
        }
        else {
            item.experimentData.defined = 0;
        }
        var isDfv = false;
        var isSwot = false;
        if (item.type == this.utilsService.issueType.DESIRABILITY.NAME ||
            item.type == this.utilsService.issueType.FEASIBILITY.NAME ||
            item.type == this.utilsService.issueType.VIABILITY.NAME) {
            item.isDfv = true;
        }
        else if (item.type == this.utilsService.issueType.STRENGTHS.NAME ||
            item.type == this.utilsService.issueType.WEAKNESSES.NAME ||
            item.type == this.utilsService.issueType.OPPORTUNITIES.NAME ||
            item.type == this.utilsService.issueType.THREATS.NAME) {
            item.isSwot = true;
        }
        item.isDfv = isDfv;
        item.isSwot = isSwot;
        return item;
    };
    DfvComponent.prototype.clearAllObj = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.desirability = [];
        ctrl.feasibility = [];
        ctrl.viability = [];
        ctrl.allStickies = [];
        // ctrl.warningOpen = false;
        // ctrl.warningMsg = ""
    };
    DfvComponent.prototype.initDFVData = function (res) {
        var ctrl = this;
        ctrl.selectedTypeConst = "DFV";
        ctrl.allStickies = res['DfvSwotData']['addStickies'].map(function (item) { return ctrl.formatIssueData(item); });
        ctrl.desirability = res['DfvSwotData']['desirability'].map(function (item) { return ctrl.formatIssueData(item); });
        ctrl.feasibility = res['DfvSwotData']['feasibility'].map(function (item) { return ctrl.formatIssueData(item); });
        ctrl.viability = res['DfvSwotData']['viability'].map(function (item) { return ctrl.formatIssueData(item); });
        ctrl.modalData = {
            distInputs: res['ColHeaders'],
            inputTypeLt: res['RadioOrCheckBox'],
            npvData: res['NPVSwing']
        };
    };
    DfvComponent.prototype.showNoteDialog = function () {
        console.log('showNoteDialog');
    };
    return DfvComponent;
}());
exports.DfvComponent = DfvComponent;
function getDropDetails(ev) {
    ev.preventDefault();
    var data = ev.originalEvent.dataTransfer.getData('text/plain');
    var draggable = document.getElementById(data);
    var textarea = draggable.getElementsByTagName('textarea');
    var nameGot = textarea[0].value;
    var dfv = data.split(":")[0];
    var id = parseInt(data.split(":")[1]);
    return { nameGot: nameGot, dfv: dfv, id: id };
}
angular.module('smartorg.r6.acts.dfv', []).component('dfv', {
    template: require('./dfv.component.html'),
    controller: DfvComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
})
    // .directive('noteContent', function () {
    //     return {
    //         restrict: 'E',
    //         link: function (scope, element, attrs) {
    //             element.bind('click', function () {
    //                 scope.contenteditable = true;
    //                 console.log(element);
    //                 console.log(attrs);
    //             });
    //             element.bind('mouseout', function () {
    //                 scope.contenteditable = false;
    //                 console.log(element);
    //                 console.log(attrs);
    //             });
    //         }
    //     };
    // })
    // .directive('noteTitle', function(){
    //     return {
    //         restrict: 'E',
    //         link: function (scope, element, attrs) {
    //             element.bind('click', function () {
    //                 scope.contenteditable = true;
    //                 console.log(element);
    //                 console.log(attrs);
    //             });
    //             element.bind('mouseleave', function () {
    //                 scope.contenteditable = false;
    //                 console.log('mouseleave');
    //                 console.log(attrs);
    //             });
    //             element.bind('mouseout', function () {
    //                 scope.contenteditable = false;
    //                 console.log('mouseout');
    //                 console.log(attrs);
    //             });
    //         }
    //     };
    // })
    .directive('note', function ($document) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<div class="note"><div class="noteBody" ng-transclude></div></div>',
        link: function (scope, element, attr) {
            element.on('dragstart', function (ev) {
                scope.$emit('DragStart', { 'id': ev.target.id });
                ev.originalEvent.dataTransfer.setData('text/plain', ev.target.id);
                setTimeout(function () {
                    // element.addClass('lowOpacity');
                    // ev.target.classList.add('hide');
                }, 0);
                if (ev.target.id.indexOf('default') !== -1) {
                    scope.$emit('CopiedFromAllStickies', { 'status': true });
                }
                else {
                    scope.$emit('CopiedFromAllStickies', { 'status': false });
                }
                scope.$apply();
            });
        }
    };
})
    .directive('dragDropAddStickies', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'DEFAULT', 'container': element, 'event': event });
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, dfv = _a.dfv, id = _a.id;
                scope.$emit('DropAddStickies', { 'issue': nameGot, dfv: dfv, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropDesirability', function () {
    return {
        link: function (scope, element) {
            // element.on('dragenter', function (ev) {
            //    console.log(ev);
            //    scope.$emit('DragEnter', { 'type': 'DESIRABILITY' });
            // });
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'DESIRABILITY', 'container': element, 'event': event });
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, dfv = _a.dfv, id = _a.id;
                scope.$emit('DropDesirability', { 'issue': nameGot, dfv: dfv, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropFeasibility', function () {
    return {
        link: function (scope, element) {
            // element.on('dragenter', function (ev) {
            //     console.log(ev);
            //     scope.$emit('DragEnter', { 'type': 'FEASIBILITY' });
            //  });
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'FEASIBILITY', 'container': element, 'event': event });
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, dfv = _a.dfv, id = _a.id;
                scope.$emit('DropFeasibility', { 'issue': nameGot, dfv: dfv, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropViability', function () {
    return {
        link: function (scope, element) {
            // element.on('dragenter', function (ev) {
            //     console.log(ev);
            //     scope.$emit('DragEnter', { 'type': 'VIABILITY' });
            //  });
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': 'VIABILITY', 'container': element, 'event': event });
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, dfv = _a.dfv, id = _a.id;
                scope.$emit('DropViability', { 'issue': nameGot, dfv: dfv, id: id, 'container': element });
            });
        }
    };
});
module.exports = 'smartorg.r6.acts.dfv';
//# sourceMappingURL=dfv.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/dfv/dfv.component.js